import { travel, axiosConfig } from 'api';

import { RequestHistoryPayload, RequestHistoryResponse, RequestHistoryV2Response } from 'models/requestHistory';
import { Response as R } from 'models/response';

interface Response {
  data: RequestHistoryResponse;
}

export const fetchRequestHistory = (userId: string) =>
  travel.get<Response>('travels/GetRequestHistory', { ...axiosConfig });

export const fetchRequestHistoryV2 = (payload: RequestHistoryPayload) =>
  travel.post<R<RequestHistoryV2Response>>('travels/GetRequestHistoryV2', payload);
